'use strict';

// TOOLTIP
// ----------------------------------------------------------------------------
var showTooltip = function (options) {
    var mqDesktop = 768;

    function displayIsBiggerThanBreakpoint(bp) {
        var displayWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return displayWidth >= bp;
    }

    var $body = $('body');
    var $tooltipWrap = $('[data-tooltip="wrap"]');
    var $overlay;
    var $tooltip;
    var hasDropBubble = false;

    var settings = $.extend({
        style: 'info',
        title: '¡Nuevo!',
        text: 'Descubre tu nueva área de gestión.',
        buttonText: 'Entendido'
    }, options);


    if($tooltipWrap.data('dropbubble') === 'open') {
        hasDropBubble = true;
    }

    var closeOverlay = function() {
        $('[data-modal="modal"]').hide();
        $('.modal-dialog').hide();
        $('.mt-tooltip').remove();
        $body.removeClass('is--modal-open');
        $('.is--in-front').removeClass('is--in-front');

        if(hasDropBubble) {
            $tooltipWrap.attr('data-dropbubble', 'open');
        }
    };

    var createOverlay = function() {
        $('.mt-overlay').remove();
        $overlay = $('<div>', {
            id: 'm-tooltip',
            class: 'mt-overlay',
            click: function() {
                closeOverlay();
            }
        });
        $overlay.appendTo($body);
    };

    var createTooltip = function() {
        $tooltip = $('<div>', {
            class: 'mt-tooltip mt-toast mt-toast--' + settings.style,
            style: 'opacity: 1; '
        });

        var $titleWrap = $('<h2>', {
            class: 'mt-toast__title',
            text: settings.title
        });

        var $paragraphWrap = $('<p>', {
            class: 'mt-toast__text',
            text: settings.text
        });

        var $buttonWrap = $('<button>', {
            class: 'btn btn-border-dark test-mt-tooltip',
            text: settings.buttonText,
            click: function(e) {
                closeOverlay();
                e.preventDefault();
            }
        });

        $titleWrap.appendTo($tooltip);
        $paragraphWrap.appendTo($tooltip);
        $buttonWrap.appendTo($tooltip);
        $tooltip.appendTo($tooltipWrap);

        if(hasDropBubble) {
            $tooltipWrap.removeAttr('data-dropbubble');
        }
        $('[data-tooltip="front"]').addClass('is--in-front');
    };

    var initTooltip = function() {
        if( displayIsBiggerThanBreakpoint(mqDesktop) ) {
            $body.addClass('is--modal-open');
            createOverlay();
            createTooltip();
        }
    };

    return initTooltip();
};
